<template>
  <div class="page about-page">
    <h1>{{ page.heading }}</h1>
    <div class="story-content">
      <p class="paragraph">
        滋仙草扎根云南，围绕石斛做长期投入。石斛原料来自云南龙陵的高海拔种植基地，并从石斛延伸到天麻等其他原料的即食原浆，
        希望把新中式养生的日常喝法做得更简单。
      </p>
      <div class="content-block">
        <h2>从产区出发</h2>
        <p class="paragraph">
          石斛原料主要来自云南龙陵的种植基地；三七来自云南文山；灵芝原料来自高黎贡山一带。
          品牌在云南设有多处基地，把种植、采收与加工串在同一条链路上。
        </p>
      </div>
      <div class="content-block">
        <h2>产品系列</h2>
        <p class="paragraph">
          目前公开了石斛系列与天麻系列的即食原浆产品，包含紫皮石斛、铁皮石斛与乌天麻三个原料品种的盒装与量贩装规格。
          全部产品与参数对照见<a href="/products.html">匠心产品</a>，
          各规格的配料、保质期与食用方法见对应产品页。
        </p>
      </div>
      <div class="content-block">
        <h2>产地溯源直播</h2>
        <p class="paragraph">
          我们习惯把镜头带到种植基地和加工现场，让原料从哪来、怎么处理，都可以被看见。
          相关说明见<a href="/quality.html">品质信息</a>。
        </p>
      </div>
    </div>
    <ContactFriend placement="hero" />
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/about.html')

export default {
  name: 'AboutPage',
  components: {
    ContactFriend
  },
  data() {
    return { page }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 12px;
}

h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 0 0 6px;
}

.paragraph {
  color: #333;
  line-height: 1.8;
  margin: 0;
}

.story-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.content-block {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.06);
}

a {
  color: #6a1bb0;
}
</style>
